<template>
  <div class="home mt-5">
    <!-- Hero Section -->
    <section class="hero">
      <div class="container text-center">
        <img src="../assets/logo_detail.png" alt="Logo" class="hero-logo" width="512px" height="auto"/>
        <h1 class="hero-title">Konfirmasi Pelanggaran Tilang Elektronik</h1>
        <p class="hero-text">
          Masukkan No Registrasi dan TNKB kendaraan untuk cek pelanggaran Anda.
        </p>
        <router-link to="/konfirmasi" class="btn btn-primary hero-btn">
          Konfirmasi Sekarang
        </router-link>
      </div>
    </section>

    <!-- Mekanisme Singkat -->
    <section class="mekanisme">
      <div class="container text-center">
        <h2>Mekanisme Tilang Elektronik</h2>
        <div class="steps">
          <div class="step">
            <img src="../assets/WIM.png" alt="Tahap 1" class="rounded-circle" />
            <p>Perangkat menangkap pelanggaran Over Dimensi & Overload secara otomatis melalui perangkat WIM.</p>
          </div>
          <div class="step">
            <img src="../assets/tahap4.svg" alt="Tahap 4" />
            <p>Pemilik kendaraan konfirmasi via website atau posko.</p>
          </div>
          <div class="step">
            <img src="../assets/tahap5.svg" alt="Tahap 5" />
            <p>Pembayaran denda dilakukan.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home'
};
</script>

<style scoped>
.home {
  font-family: 'Poppins', sans-serif;
  color: #333;
}

.hero {
  padding: 80px 20px;
  background: #f8f9fa;
}
.hero-logo {
  width: 200px;
  margin-bottom: 20px;
}
.hero-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 10px;
}
.hero-text {
  font-size: 1rem;
  margin-bottom: 20px;
}
.hero-btn {
  padding: 10px 25px;
  font-weight: 600;
  border-radius: 25px;
}

.mekanisme {
  padding: 60px 20px;
}
.mekanisme h2 {
  font-weight: 700;
  margin-bottom: 40px;
}
.steps {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
}
.step {
  max-width: 250px;
}
.step img {
  width: 80px;
  margin-bottom: 15px;
}
.step p {
  font-size: 0.95rem;
}

.quotes {
  background: #d8d8d8;
  color: #000;
  padding: 50px 20px;
  font-style: italic;
  border-radius: 10px 10px 0 0;
}
</style>
